<div class="footer">
  <p>&copy; 2022 -2025 - Inobu AB</p>
</div>
